import axios from 'axios';
import i18n from '@/i18n';


const path = require('path');

const DEV_AUTH = process.env.NODE_ENV === 'development' ? true : false;
const DEV_USERNAME = process.env.VUE_APP_LOGIN_API_USERNAME;
const DEV_PASSWORD = process.env.VUE_APP_LOGIN_API_PASSWORD;

  if (!DEV_AUTH) {
    axios.defaults.headers.common['X-CSRFToken'] = (name => {
      var re = new RegExp(`(?:^|; )${name}=([^;]+)`); // is `^name` or `; name`
      var value = re.exec(document.cookie);
      return (value != null) ? decodeURIComponent(value[1]) : null;
    })('csrftoken');
  }

class ApiClient {
  // API routes
  LOGIN_API_PATH = "/login";
  ORGANISATION_API_PATH = "/organisation/";
  PERSONAL_DATA_URL = "/personal-data/";
  USERGROUP_API_PATH = "/usergroup/";

  constructor() {
    this.client = axios.create();

    this.client.interceptors.request.use(
      (config) => {
        if (DEV_AUTH) {
          const base64Credentials = btoa(`${DEV_USERNAME}:${DEV_PASSWORD}`);
          config.headers.Authorization = `Basic ${base64Credentials}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  routeContainsDomain(route) {
    try {
      const url = new URL(route);
      return Boolean(url.hostname);
    } catch (error) {
      return false;
    } 
  }

  get(route, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.get(url, config);
  }

  post(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.post(url, data, config);
  }

  put(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.put(url, data, config);
  }

  delete(route, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.delete(url, config);
  }

  patch(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.patch(url, data, config);
  }
};

export default ApiClient;